module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/assign.js
// module id = 117
// module chunks = 35783957827783 114276838955818 162898551421021